export const currentModulesHandle = [
  {
    module: "leads",
    view: false,
    actions: {
      create: false,
      update: false,
    },
    special_actions: {
      export: false,
    },
  },
  {
    module: "prospectos",
    view: false,
    actions: {},
    special_actions: {
      export: false,
    },
  },
  {
    module: "chats",
    view: false,
    actions: {},
    special_actions: {
      export: false,
      export_chat: false,
      delete_chat: false,
      human_atention: false,
      can_block_contact: false,
      create_chat: false,
      filters: false,
    },
  },
  {
    module: "horarios de atención",
    view: false,
    actions: {
      update: false,
    },
    special_actions: {},
  },
  {
    module: "contactos",
    view: false,
    actions: {
      create: false,
      update: false,
      delete: false,
    },
    special_actions: {
      export: false,
    },
  },
  {
    module: "productos",
    view: false,
    actions: {
      create: false,
      status: false,
      update: false,
      delete: false,
    },
    special_actions: {
      export: false,
    },
  },
  {
    module: "perfiles",
    view: false,
    actions: {
      create: false,
      status: false,
      update: false,
      delete: false,
    },
    special_actions: {
      export: false,
      link_documents_rh: false,
    },
  },
  {
    module: "aprendizaje",
    view: false,
    actions: {
      create: false,
      delete: false,
    },
    special_actions: {},
  },
  {
    module: "pagos",
    view: false,
    actions: {
      create: false,
      update: false,
      delete: false,
    },
    special_actions: {
      export: false,
    },
  },
  {
    module: "tickets",
    view: false,
    actions: {
      create: false,
      update: false,
      delete: false
    },
    special_actions: {
      export: false
    },
  },
  {
    module: "dashboard leads",
    view: false,
    actions: {
      create: false,
      update: false,
      delete: false
    },
    special_actions: {
      export: false
    },

  }
];
